import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from 'src/common/TailwindComponents';
import formatLongDate from 'src/common/utils/Dates/formatLongDate';

const AssignableScreenings = ({
    screenings,
    selectedScreenIds,
    onToggleSelect,
    onToggleAll,
}) => (
  <div className="space-y-2">
    <div className="flex items-center space-x-2 mb-4">
      <Checkbox
        id="toggle-select-all-screen"
        checked={selectedScreenIds.length === screenings.length}
        onChange={() => onToggleAll()}
        className="self-center"
      />
      <span>{`${selectedScreenIds.length} of ${screenings.length} screenings selected for assignment.`}</span>
    </div>
    {screenings.map((screen) => (
      <div key={screen.id} className="flex items-center p-4 bg-white border rounded-lg shadow-sm hover:bg-gray-50">
        <div className="flex items-start w-1/3 space-x-2">
          <Checkbox
            id={`select-screen-${screen.id}`}
            checked={selectedScreenIds.includes(screen.id)}
            onChange={() => onToggleSelect(screen.id)}
            className="self-center"
          />
          <div>
            <div className="font-medium">{screen.client_name}</div>
            <div className="text-sm text-gray-500">{screen.type}</div>
          </div>
        </div>
        <div className="w-2/6 text-gray-700">{screen.organization_name}</div>
        <div className="w-1/6 text-gray-700">{formatLongDate(screen.updated_at)}</div>
        <div className="w-1/6 text-gray-700">{screen.assigned}</div>
      </div>
    ))}
  </div>
);

AssignableScreenings.propTypes = {
    screenings: PropTypes.array.isRequired,
    selectedScreenIds: PropTypes.array.isRequired,
    onToggleSelect: PropTypes.func.isRequired,
    onToggleAll: PropTypes.func.isRequired,
};

export default AssignableScreenings;
